import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.widget.company.comment');
import { OnInit, Input, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { ElementRef, ViewChild } from '@angular/core';
import { ClassicEditor, CKEditorPlugins } from "src/libs/portal/season/ckeditor";

@Component({
    selector: 'wiz-portal-lpsysadmin-widget-company-comment',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.lpsysadmin.widget.company.comment/view.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.notion-editor-wrap .ck.ck-editor {
  display: flex;
  flex-direction: column;
}
.notion-editor-wrap .ck-editor__main {
  flex: 1;
  min-height: 0;
}
.notion-editor-wrap .ck-content {
  min-height: 400px !important;
  padding: 16px 0 !important;
  border: none !important;
  border-top: 1px solid #f4f4f5 !important;
  box-shadow: none !important;
}
.notion-editor-wrap .ck-content:focus {
  border-color: #e4e4e7 !important;
  box-shadow: none !important;
}
.notion-editor-wrap .ck-content p {
  margin: 0.3em 0;
  line-height: 1.75;
  color: #3f3f46;
}
.notion-editor-wrap .ck-content h2 {
  font-size: 1.5em;
  font-weight: 700;
  margin-top: 1.4em;
  margin-bottom: 0.3em;
  color: #18181b;
}
.notion-editor-wrap .ck-content h3 {
  font-size: 1.2em;
  font-weight: 600;
  margin-top: 1.1em;
  margin-bottom: 0.2em;
  color: #27272a;
}
.notion-editor-wrap .ck-content blockquote {
  border-left: 3px solid #e4e4e7;
  padding-left: 16px;
  color: #71717a;
  margin: 1em 0;
}
.notion-editor-wrap .ck.ck-toolbar {
  border: none !important;
  border-bottom: 1px solid #f4f4f5 !important;
  background: transparent !important;
  padding: 4px 0 !important;
}

.notion-content p {
  margin: 0.4em 0;
  line-height: 1.8;
}
.notion-content h2 {
  font-size: 1.5em;
  font-weight: 700;
  margin-top: 1.5em;
  margin-bottom: 0.4em;
  color: #18181b;
}
.notion-content h3 {
  font-size: 1.2em;
  font-weight: 600;
  margin-top: 1.2em;
  margin-bottom: 0.3em;
  color: #27272a;
}
.notion-content blockquote {
  border-left: 3px solid #e4e4e7;
  padding-left: 16px;
  color: #71717a;
  margin: 1em 0;
}
.notion-content img {
  max-width: 100%;
  border-radius: 8px;
  margin: 1em 0;
}
.notion-content table {
  border-collapse: collapse;
  width: 100%;
  margin: 1em 0;
}
.notion-content th,
.notion-content td {
  border: 1px solid #e4e4e7;
  padding: 8px 12px;
  text-align: left;
}
.notion-content th {
  background: #fafafa;
  font-weight: 600;
}
.notion-content code {
  background: #f4f4f5;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 0.9em;
}
.notion-content pre {
  background: #fafafa;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  padding: 16px;
  overflow-x: auto;
}
.notion-content pre code {
  background: none;
  padding: 0;
}

.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}`],
})
export class PortalLpsysadminWidgetCompanyCommentComponent implements OnInit, OnDestroy {
    @ViewChild('editor')
    public editorElement: ElementRef;
    public editor: any;

    constructor(@Inject( Service) public service: Service) { }

    @Input() company: any;
    @Input() category: any;

    public list: any = [];
    public selectedItem: any = null;
    public mode: string = 'list';
    public title: string = '';

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    ngOnDestroy() {
        this.destroyEditor();
    }

    private destroyEditor() {
        if (this.editor) {
            this.editor.destroy().catch(() => { });
            this.editor = null;
        }
    }

    public async load() {
        const { code, data } = await wiz.call("search", { company_id: this.company.id });
        if (code === 200) {
            this.list = data;
        }
        await this.service.render();
    }

    // 새 글 작성 — 바로 페이지 열기
    public async startWrite() {
        this.selectedItem = { extra: { attachments: [] } };
        this.title = '';
        this.mode = 'edit';
        await this.service.render();
        await this.initEditor('');
    }

    // 기존 글 열기 — 읽기 모드
    public async openItem(item: any) {
        const { code, data } = await wiz.call("get", { id: item.id });
        if (code !== 200) return;
        this.selectedItem = data;
        this.title = data.extra?.title || '';
        this.mode = 'view';
        await this.service.render();
    }

    // 읽기 → 편집 전환
    public async startEdit() {
        this.mode = 'edit';
        await this.service.render();
        await this.initEditor(this.selectedItem?.content || '');
    }

    private async initEditor(content: string) {
        this.destroyEditor();
        await this.service.render();

        let element: any = this.editorElement?.nativeElement;
        if (!element) return;

        let toolbar = 'heading | bold italic strikethrough underline | blockQuote code | bulletedList numberedList todoList | outdent indent | uploadImage insertTable link codeBlock horizontalLine | specialCharacters'.split(' ');

        this.editor = await ClassicEditor.create(element, {
            toolbar: {
                items: toolbar,
                shouldNotGroupWhenFull: true
            },
            removePlugins: ["MediaEmbedToolbar"],
            plugins: CKEditorPlugins,
            simpleUpload: {
                uploadUrl: '/file/upload'
            },
            placeholder: '투자포인트, 미팅 메모, 기업 분석 등을 자유롭게 작성하세요...'
        });

        if (content) {
            this.editor.data.set(content);
        }
    }

    public async save() {
        if (!this.editor) return;
        let content = this.editor.data.get();
        if (!content || content.trim() === '' || content.trim() === '<p>&nbsp;</p>') {
            await this.alert("내용을 입력해주세요.");
            return;
        }

        let data: any = {
            content: content,
            company_id: this.company.id,
            extra: this.selectedItem?.extra || {}
        };
        data.extra.title = this.title || '';

        if (this.selectedItem?.id) {
            data.id = this.selectedItem.id;
        }

        const { code, data: res } = await wiz.call("update", { data: JSON.stringify(data) });
        if (code === 200) {
            await this.alert('저장되었습니다', 'success');
            this.destroyEditor();
            // 저장 후 해당 글을 다시 읽기 모드로
            const itemId = res.id || this.selectedItem?.id;
            if (itemId) {
                await this.load();
                const { code: c2, data: d2 } = await wiz.call("get", { id: itemId });
                if (c2 === 200) {
                    this.selectedItem = d2;
                    this.title = d2.extra?.title || '';
                    this.mode = 'view';
                    await this.service.render();
                    return;
                }
            }
            await this.goBack();
        } else {
            await this.alert('저장에 실패했습니다.');
        }
    }

    public async deleteItem(item: any, event?: any) {
        if (event) event.stopPropagation();
        let res: any = await this.alert("정말로 삭제하시겠습니까?", "error", "취소", "삭제");
        if (!res) return;
        await wiz.call("delete", { id: item.id });
        if (this.selectedItem?.id === item.id) {
            await this.goBack();
            return;
        }
        await this.load();
    }

    public async deleteCurrentItem() {
        if (!this.selectedItem?.id) return;
        let res: any = await this.alert("이 글을 삭제하시겠습니까?", "error", "취소", "삭제");
        if (!res) return;
        await wiz.call("delete", { id: this.selectedItem.id });
        await this.goBack();
    }

    public async goBack() {
        this.destroyEditor();
        this.mode = 'list';
        this.selectedItem = null;
        this.title = '';
        await this.load();
    }

    public async upload() {
        let files = await this.service.file.select();
        if (files.length == 0) return;

        await this.service.loading.show();

        if (!this.selectedItem) this.selectedItem = { extra: {} };
        if (!this.selectedItem.extra) this.selectedItem.extra = {};
        if (!this.selectedItem.extra.attachments) this.selectedItem.extra.attachments = [];

        for (let i = 0; i < files.length; i++) {
            let fd = new FormData();
            fd.append('upload', files[i]);
            let fdurl = '/file/upload';
            const { url } = await this.service.file.upload(fdurl, fd, async (percent: number) => { });
            this.selectedItem.extra.attachments.push({ name: files[i].name, url: url });
        }

        await this.service.loading.hide();
        await this.service.render();
    }

    public async removeFile(file: any) {
        let res: any = await this.alert("파일을 삭제하시겠습니까?", "error", "취소", "삭제");
        if (!res) return;
        this.selectedItem.extra.attachments.remove(file);
        await this.service.render();
    }

    public getTitle(item: any) {
        if (item.extra?.title) return item.extra.title;
        let text = (item.content || '').replace(/<[^>]+>/g, '').trim();
        return text.length > 60 ? text.substring(0, 60) + '...' : text || '(제목 없음)';
    }

    public getPreview(item: any) {
        let text = (item.content || '').replace(/<[^>]+>/g, '').trim();
        if (item.extra?.title) {
            return text.length > 120 ? text.substring(0, 120) + '...' : text;
        }
        return text.length > 120 ? text.substring(0, 120) + '...' : '';
    }

    public async alert(message: string, status: string = 'error', cancel: any = false, action: string = '확인') {
        return await this.service.alert.show({
            title: "",
            message: message,
            cancel: cancel,
            actionBtn: status,
            action: action,
            status: status
        });
    }
}

export default PortalLpsysadminWidgetCompanyCommentComponent;